import React from 'react';
import { COLORS } from '../../styles/tokens';

export interface IconBadgeProps {
  children: React.ReactNode;
  /** Pastel-tint background colour. Use COLORS.tintPink/Purple/Blue/Mint. */
  tint?: string;
  /** Square size in px. */
  size?: number;
  /** Border radius — defaults to a rounded square. */
  radius?: number;
}

// Small icon container used inside cards (CardHeader-style). Pastel tint +
// thin white border. Single source of truth so all icon badges look uniform.
export default function IconBadge({
  children,
  tint = COLORS.tintPurple,
  size = 44,
  radius = 14,
}: IconBadgeProps) {
  return (
    <div style={{
      width: size,
      height: size,
      borderRadius: radius,
      background: tint,
      border: `1px solid ${COLORS.glassBorder}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    }}>
      {children}
    </div>
  );
}
